import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  return (
    <a
      // href="https://wa.me/919552982935?text=%7C%7C%E0%A4%9C%E0%A4%AF%20%E0%A4%B9%E0%A4%B0%E0%A4%BF%20%E0%A4%AE%E0%A4%BE%E0%A4%8A%E0%A4%B2%E0%A5%80%7C%7C"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-4 bg-green-500 hover:bg-green-600 text-white p-3 text-3xl rounded-full shadow-lg z-50 animate-pulse hover:scale-110 transition-transform duration-300"
      title="Contact us on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};

export default WhatsAppButton;
